module.exports = __webpack_public_path__ + "img/logo-santander.f8eb7ad6.png";